import { Component, inject } from '@angular/core';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.scss'],
})
export class AdminsComponent {
  private adminService = inject(AdminService);

  public openSendSignupInvitationDialog(): void {
    this.adminService.openSendSignupInvitationDialog();
  }
}
